import { collection, addDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

// Sample data for demo purposes
export const sampleTeams = [
  {
    name: 'Green Court Warriors',
    players: [
      { name: 'Ahmed Hassan', email: 'ahmed@example.com' },
      { name: 'Sarah Johnson', email: 'sarah@example.com' }
    ],
    matchesPlayed: 0,
    wins: 0,
    losses: 0,
    points: 0
  },
  {
    name: 'Padel Masters',
    players: [
      { name: 'Mohammed Ali', email: 'mohammed@example.com' },
      { name: 'Fatima Ahmed', email: 'fatima@example.com' }
    ],
    matchesPlayed: 0,
    wins: 0,
    losses: 0,
    points: 0
  },
  {
    name: 'Court Champions',
    players: [
      { name: 'Omar Khalil', email: 'omar@example.com' },
      { name: 'Aisha Rahman', email: 'aisha@example.com' }
    ],
    matchesPlayed: 0,
    wins: 0,
    losses: 0,
    points: 0
  },
  {
    name: 'Smash Kings',
    players: [
      { name: 'Yusuf Ibrahim', email: 'yusuf@example.com' },
      { name: 'Zainab Ali', email: 'zainab@example.com' }
    ],
    matchesPlayed: 0,
    wins: 0,
    losses: 0,
    points: 0
  }
];

export const samplePlayers = [
  {
    name: 'Ahmed Hassan',
    email: 'ahmed@example.com',
    phone: '+971501234567',
    dateOfBirth: '1990-05-15',
    emergencyContact: 'Hassan Family',
    emergencyPhone: '+971501234568',
    medicalInfo: 'No known allergies',
    notes: 'Experienced player with 5 years of padel experience'
  },
  {
    name: 'Sarah Johnson',
    email: 'sarah@example.com',
    phone: '+971501234569',
    dateOfBirth: '1988-03-22',
    emergencyContact: 'Johnson Family',
    emergencyPhone: '+971501234570',
    medicalInfo: 'Asthma - carries inhaler',
    notes: 'Former tennis player, new to padel'
  },
  {
    name: 'Mohammed Ali',
    email: 'mohammed@example.com',
    phone: '+971501234571',
    dateOfBirth: '1992-11-08',
    emergencyContact: 'Ali Family',
    emergencyPhone: '+971501234572',
    medicalInfo: 'No known conditions',
    notes: 'Professional padel instructor'
  },
  {
    name: 'Fatima Ahmed',
    email: 'fatima@example.com',
    phone: '+971501234573',
    dateOfBirth: '1991-07-14',
    emergencyContact: 'Ahmed Family',
    emergencyPhone: '+971501234574',
    medicalInfo: 'No known conditions',
    notes: 'Competitive player with tournament experience'
  },
  {
    name: 'Omar Khalil',
    email: 'omar@example.com',
    phone: '+971501234575',
    dateOfBirth: '1989-12-03',
    emergencyContact: 'Khalil Family',
    emergencyPhone: '+971501234576',
    medicalInfo: 'No known conditions',
    notes: 'Team captain material'
  },
  {
    name: 'Aisha Rahman',
    email: 'aisha@example.com',
    phone: '+971501234577',
    dateOfBirth: '1993-09-18',
    emergencyContact: 'Rahman Family',
    emergencyPhone: '+971501234578',
    medicalInfo: 'No known conditions',
    notes: 'Quick learner, great potential'
  },
  {
    name: 'Yusuf Ibrahim',
    email: 'yusuf@example.com',
    phone: '+971501234579',
    dateOfBirth: '1987-04-25',
    emergencyContact: 'Ibrahim Family',
    emergencyPhone: '+971501234580',
    medicalInfo: 'No known conditions',
    notes: 'Strategic player with excellent court vision'
  },
  {
    name: 'Zainab Ali',
    email: 'zainab@example.com',
    phone: '+971501234581',
    dateOfBirth: '1994-01-12',
    emergencyContact: 'Ali Family',
    emergencyPhone: '+971501234582',
    medicalInfo: 'No known conditions',
    notes: 'Young talent with aggressive playing style'
  }
];

export const sampleLeague = {
  name: 'OffCourt Spring Championship 2024',
  season: 'Spring 2024',
  startDate: '2024-03-01',
  endDate: '2024-05-31',
  setsPerMatch: 3,
  pointsPerWin: 3,
  pointsPerDraw: 1,
  pointsPerLoss: 0,
  matchDuration: 60,
  courtCount: 2,
  description: 'The premier padel league championship featuring the best teams in the region.',
  status: 'upcoming'
};

// Function to generate fixtures for a round-robin tournament with 4 matches per team pairing
export const generateFixtures = (teams) => {
  const fixtures = [];
  const teamCount = teams.length;
  
  // Round-robin algorithm
  for (let round = 0; round < teamCount - 1; round++) {
    for (let match = 0; match < teamCount / 2; match++) {
      const team1Index = (round + match) % (teamCount - 1);
      const team2Index = (teamCount - 1 - match + round) % (teamCount - 1);
      
      // Last team stays in place
      const team1 = team1Index === team2Index ? teamCount - 1 : team1Index;
      const team2 = team2Index === team1Index ? teamCount - 1 : team2Index;
      
      if (team1 !== team2) {
        // Create 4 matches for each team pairing with different player combinations
        const team1Name = teams[team1].name;
        const team2Name = teams[team2].name;
        const team1Id = teams[team1].id;
        const team2Id = teams[team2].id;
        
        // Match 1: Player 1 vs Player 1, Player 2 vs Player 2
        fixtures.push({
          homeTeam: team1Name,
          awayTeam: team2Name,
          homeTeamId: team1Id,
          awayTeamId: team2Id,
          round: round + 1,
          matchNumber: fixtures.length + 1,
          court: `Court ${(match % 2) + 1}`,
          status: 'scheduled',
          matchType: 'Player 1 vs Player 1, Player 2 vs Player 2',
          pairing: {
            home: { player1: 'Player 1', player2: 'Player 2' },
            away: { player1: 'Player 1', player2: 'Player 2' }
          }
        });
        
        // Match 2: Player 1 vs Player 2, Player 2 vs Player 1
        fixtures.push({
          homeTeam: team1Name,
          awayTeam: team2Name,
          homeTeamId: team1Id,
          awayTeamId: team2Id,
          round: round + 1,
          matchNumber: fixtures.length + 1,
          court: `Court ${(match % 2) + 1}`,
          status: 'scheduled',
          matchType: 'Player 1 vs Player 2, Player 2 vs Player 1',
          pairing: {
            home: { player1: 'Player 1', player2: 'Player 2' },
            away: { player1: 'Player 2', player2: 'Player 1' }
          }
        });
        
        // Match 3: Player 2 vs Player 1, Player 1 vs Player 2
        fixtures.push({
          homeTeam: team1Name,
          awayTeam: team2Name,
          homeTeamId: team1Id,
          awayTeamId: team2Id,
          round: round + 1,
          matchNumber: fixtures.length + 1,
          court: `Court ${(match % 2) + 1}`,
          status: 'scheduled',
          matchType: 'Player 2 vs Player 1, Player 1 vs Player 2',
          pairing: {
            home: { player1: 'Player 2', player2: 'Player 1' },
            away: { player1: 'Player 1', player2: 'Player 2' }
          }
        });
        
        // Match 4: Player 2 vs Player 2, Player 1 vs Player 1
        fixtures.push({
          homeTeam: team1Name,
          awayTeam: team2Name,
          homeTeamId: team1Id,
          awayTeamId: team2Id,
          round: round + 1,
          matchNumber: fixtures.length + 1,
          court: `Court ${(match % 2) + 1}`,
          status: 'scheduled',
          matchType: 'Player 2 vs Player 2, Player 1 vs Player 1',
          pairing: {
            home: { player1: 'Player 2', player2: 'Player 1' },
            away: { player1: 'Player 2', player2: 'Player 1' }
          }
        });
      }
    }
  }
  
  return fixtures;
};

// Function to populate sample data
export const populateSampleData = async () => {
  try {
    console.log('Populating sample data...');
    
    // Create sample league
    const leagueRef = await addDoc(collection(db, 'leagues'), {
      ...sampleLeague,
      createdAt: new Date().toISOString()
    });
    console.log('Sample league created:', leagueRef.id);
    
    // Create sample players
    const playerRefs = [];
    for (const player of samplePlayers) {
      const playerRef = await addDoc(collection(db, 'players'), {
        ...player,
        matchesPlayed: 0,
        aces: 0,
        unforcedErrors: 0,
        kickSmashes: 0,
        akhlaaqRating: 0,
        totalPoints: 0,
        createdAt: new Date().toISOString(),
        teamId: null,
        teamName: null
      });
      playerRefs.push({ id: playerRef.id, ...player });
    }
    console.log('Sample players created:', playerRefs.length);
    
    // Create sample teams
    const teamRefs = [];
    for (let i = 0; i < sampleTeams.length; i++) {
      const team = sampleTeams[i];
      const teamPlayers = playerRefs.slice(i * 2, (i + 1) * 2);
      
      const teamRef = await addDoc(collection(db, 'teams'), {
        ...team,
        players: teamPlayers.map(p => ({ id: p.id, name: p.name })),
        playerIds: teamPlayers.map(p => p.id),
        createdAt: new Date().toISOString()
      });
      
      teamRefs.push({ id: teamRef.id, ...team });
      
      // Update players with team assignment
      for (const player of teamPlayers) {
        // Note: In a real app, you'd use batch writes
        console.log(`Player ${player.name} assigned to team ${team.name}`);
      }
    }
    console.log('Sample teams created:', teamRefs.length);
    
    // Generate and create fixtures
    const fixtures = generateFixtures(teamRefs);
    for (const fixture of fixtures) {
      const fixtureRef = await addDoc(collection(db, 'fixtures'), {
        ...fixture,
        date: new Date(Date.now() + Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        time: `${9 + Math.floor(Math.random() * 8)}:00`,
        createdAt: new Date().toISOString()
      });
      console.log('Fixture created:', fixtureRef.id);
    }
    console.log('Sample fixtures created:', fixtures.length);
    
    console.log('Sample data population completed!');
    return true;
  } catch (error) {
    console.error('Error populating sample data:', error);
    return false;
  }
};
